import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_4 = ["name", "id", "rows", "placeholder", "value", "disabled", "maxlength", "required", "readonly"]
const _hoisted_5 = {
  key: 1,
  class: "inline-flex items-center px-3 m-0 border border-r-0 rounded-l border-neutral-100 bg-gray-50 text-neutral-400"
}
const _hoisted_6 = ["type", "name", "id", "placeholder", "value", "disabled", "min", "max", "step", "maxlength", "required", "readonly"]
const _hoisted_7 = {
  key: 4,
  class: "absolute right-0 z-10 inline-flex items-center px-3 py-3 m-0 text-neutral-400"
}
const _hoisted_8 = {
  key: 5,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
}
const _hoisted_9 = {
  key: 1,
  class: "text-[10px] text-gray-600 mt-1"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";

export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    helper: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: "text",
    },
    textarea: {
        type: Boolean,
        default: false,
    },
    textAreaRows: {
        type: Number,
        default: 3,
    },
    required: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    add_on_right: {
        type: Boolean,
        default: false,
    },
    add_on_text: {
        type: String,
        default: null,
    },
    add_on_left: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
    },
    step: {
        type: Number,
        default: 1,
    },
    maxlength: {
        type: Number,
    },
    showInputLimit: {
        type: Boolean,
        default: false,
    },
    customClass: {
        type: String,
        default: "",
    },
    labelClass: {
        type: String,
        default: ""
    },
    trailingIcon: {
        type: String,
        default: null,
    },
    trailingIconClass: {
        type: String,
        default: null,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full",
    id: __props.id
  }, [
    _createElementVNode("label", {
      for: __props.id,
      class: _normalizeClass(["block text-xs font-semibold text-neutral-600", __props.labelClass])
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["relative rounded", [__props.add_on_right || __props.add_on_left ? 'flex' : '', __props.label ? 'mt-2' : '']])
    }, [
      (__props.textarea)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 0,
            name: __props.name,
            id: __props.id,
            rows: __props.textAreaRows,
            class: _normalizeClass(["block w-full py-3 pl-4 pr-3 pr-10 rounded focus:outline-none focus:ring-0 disabled:bg-gray-100", [
                    __props.customClass,
                    __props.error
                        ? 'text-red-900 border-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'text-neutral-600 border-neutral-100 placeholder:font-medium placeholder-neutral-400 focus:border-neutral-900'
                ]]),
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            disabled: __props.disabled,
            maxlength: __props.maxlength,
            required: __props.required,
            readonly: __props.readonly
          }, null, 42, _hoisted_4))
        : _createCommentVNode("", true),
      (__props.add_on_left)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.add_on_text), 1))
        : _createCommentVNode("", true),
      (!__props.textarea)
        ? (_openBlock(), _createElementBlock("input", {
            key: 2,
            type: __props.type,
            name: __props.name,
            id: __props.id,
            class: _normalizeClass(["block w-full h-12 py-3 pl-4 pr-3 disabled:bg-gray-100 focus:outline-none focus:ring-0", [
                    __props.customClass,
                    __props.error
                        ? 'text-red-900 border-red-600 placeholder-red-300 focus:ring-red-500 rounded focus:border-red-500'
                        : __props.add_on_left
                        ? 'text-neutral-600 border-neutral-100 placeholder:font-medium placeholder-neutral-400 flex-1 min-w-0 block w-full px-3 py-2.5 rounded-none rounded-r focus:ring-neutral-900 focus:border-neutral-900'
                        : __props.add_on_right
                        ? 'text-neutral-600 border-neutral-100 placeholder:font-medium placeholder-neutral-400 px-3 pl-4 pr-12 rounded focus:ring-neutral-900 focus:border-neutral-900'
                        : 'text-neutral-600 border-neutral-100 placeholder:font-medium placeholder-neutral-400 rounded focus:border-neutral-900'
                ]]),
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            disabled: __props.disabled,
            min: __props.min,
            max: __props.max,
            step: __props.step,
            maxlength: __props.maxlength,
            required: __props.required,
            readonly: __props.readonly
          }, null, 42, _hoisted_6))
        : _createCommentVNode("", true),
      (__props.trailingIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass([__props.add_on_right ? 'right-12 pl-3' : 'right-0', "absolute inset-y-0 z-50 flex items-center pr-3 cursor-pointer"])
          }, [
            (__props.trailingIcon)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.trailingIcon), {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('iconClick'))),
                  "aria-hidden": "true",
                  class: _normalizeClass(["w-5 h-5 text-gray-400", __props.trailingIconClass])
                }, null, 8, ["class"]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (__props.add_on_right)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.add_on_text), 1))
        : _createCommentVNode("", true),
      (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(ExclamationCircleIcon), {
              class: "w-5 h-5 text-red-500",
              "aria-hidden": "true"
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.showInputLimit)
      ? (_openBlock(), _createElementBlock("small", {
          key: 0,
          class: _normalizeClass(["block mt-1 text-right", [
                __props.modelValue.length >= __props.maxlength
                    ? 'text-red-600'
                    : 'text-gray-400',
            ]])
        }, _toDisplayString(__props.modelValue.length) + "/" + _toDisplayString(__props.maxlength), 3))
      : _createCommentVNode("", true),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})